<template>
  <div class="task-detail-loading">
    <div class="task-detail-loading__header">
      <loading-placeholder :lines="1" />
    </div>
    <div class="task-detail-loading__action">
      <loading-placeholder :lines="8" />
    </div>
  </div>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import {
  ContentPlaceholders,
  ContentPlaceholdersText,
} from '@/components/global/content-placeholders'

/* Mixins */
/* Components */
/* Helpers */
/* Data types */
/* API */

export default defineComponent({
  name: 'TaskDetailLoading',

  components: {
    ContentPlaceholders,
    ContentPlaceholdersText,
  },
})
</script>

<style lang="scss">
.task-detail-loading {
  margin-top: 42px;
  padding: 10px $detail-gutter-pad-sm;

  @include media-breakpoint-up(md) {
    padding-right: $detail-gutter-pad-md;
    padding-left: $detail-gutter-pad-md;
  }

  @include media-breakpoint-up(lg) {
    padding-right: 0.5 * $detail-gutter-pad-lg;
    padding-left: 0.5 * $detail-gutter-pad-lg;
  }

  &__header {
    .vue-content-placeholders-text__line {
      width: 100%;
      height: 246px;
    }
  }

  &__action {
    margin-bottom: 50px;
  }
}
</style>
